export const REDUCER_NAME = "news";
export const SET_ERROR = `${REDUCER_NAME}/SET_ERROR`;
export const SET_NEWS = `${REDUCER_NAME}/SET_NEWS`;
